export default __webpack_public_path__ + "static/media/shopping-cart.95c0e210.svg";